var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4194 0C16.4706 0 16.5218 0 16.5759 0C16.7015 1.55149 16.1093 2.71075 15.3896 3.55026C14.6834 4.38396 13.7164 5.19255 12.1523 5.06986C12.048 3.5406 12.6412 2.46731 13.3599 1.62974C14.0265 0.849163 15.2485 0.154569 16.4194 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1536 16.1486C21.1536 16.1641 21.1536 16.1776 21.1536 16.1921C20.714 17.5233 20.087 18.6642 19.3219 19.723C18.6235 20.6842 17.7675 21.9778 16.2392 21.9778C14.9186 21.9778 14.0415 21.1286 12.688 21.1054C11.2563 21.0822 10.469 21.8155 9.15999 22C9.01025 22 8.86051 22 8.71367 22C7.75244 21.8609 6.9767 21.0996 6.41156 20.4137C4.74511 18.387 3.45736 15.7689 3.21777 12.4187C3.21777 12.0902 3.21777 11.7627 3.21777 11.4342C3.31921 9.03649 4.48427 7.08699 6.03286 6.14219C6.85015 5.63984 7.97367 5.21188 9.22471 5.40316C9.76087 5.48624 10.3086 5.66979 10.7888 5.85141C11.2438 6.02626 11.8128 6.33637 12.3518 6.31994C12.717 6.30932 13.0802 6.119 13.4483 5.98472C14.5264 5.5954 15.5833 5.14908 16.9763 5.35872C18.6505 5.61182 19.8388 6.35569 20.573 7.50336C19.1567 8.40469 18.0371 9.76297 18.2284 12.0825C18.3984 14.1894 19.6233 15.4221 21.1536 16.1486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.cecbdb74f505414e45438562a9d2e022.svg";
export { ForwardRef as ReactComponent };